import createLucideIcon from '../createLucideIcon';

const ArrowDown = createLucideIcon('ArrowDown', [
  ['line', { x1: '12', x2: '12', y1: '5', y2: '19', key: 'pwfkuu' }],
  ['polyline', { points: '19 12 12 19 5 12', key: '17kmxi' }],
]);

export default ArrowDown;
